import { REDIRECT } from "../constants/common.action.types";

export const redirect = () => {
  return { type: REDIRECT };
};
